import SettingsNavPoint from "./SettingsNavPoint"
import { closestCenter, DndContext } from "@dnd-kit/core"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import { Accordion, Box, Button, Icon, Text } from "@chakra-ui/react"
import { SortableItem } from "../../components/Common/SortableItem"
import { FiMenu, FiPlusCircle, FiTrash2 } from "react-icons/fi"
import { Tooltip } from "../../components/UI/tooltip"
import { addBlock, onDragEnd, removeBlock, SettingsNavPointsProps } from "../../api/navigation"


function SettingsNavPoints({
    block_num,
    me_create,
    me_read,
    ct_read,
    categories_list,
    blocks,
    insert,
    form,
    openItems,
    setOpenItems,
} : SettingsNavPointsProps) {
    const { formState: {errors} } = form

    return (
        <SettingsNavPoint
            order_number={block_num}
            parent_order_number={null}
            me_create={me_create}
            me_read={me_read}
            ct_read={ct_read}
            categories_list={categories_list}
            form={form}
        >

            <Text mt={4}>Untergeordnete Navigationspunkte</Text>

            <Box border="1px solid" borderColor="dim" borderRadius={8} mt={4}>
                <DndContext collisionDetection={closestCenter} onDragEnd={(e) => onDragEnd(e, form)}>
                    <SortableContext items={blocks.map(b => b.id)} strategy={verticalListSortingStrategy}>
                        <Accordion.Root multiple={true} value={openItems} onValueChange={(details) => setOpenItems(details.value)}>
                            {blocks?.filter(b => ((b.parent_order_number ?? 0) - 1) == block_num).map((block) => (
                                <SortableItem id={block.id} key={block.id}>
                                    {({ listeners }) => (
                                        <Accordion.Item
                                            value={block.id}
                                            px={2}
                                            py={2}
                                            divideY="1px"
                                            divideColor="main"
                                        >
                                            <Accordion.ItemTrigger>
                                                <Icon as={FiMenu} {...listeners} data-testid="drag_sub_nav" _active={{cursor: "grabbing"}} cursor="pointer" />

                                                <Box flex="1" textAlign="left" color={errors?.navs?.length != undefined ? "danger" : undefined} data-testid="title_sub_nav">
                                                    {block.title && block.title != "" ? block.title :  "Neuer Subnavigationspunkt"}

                                                    <Accordion.ItemIndicator display="none" />
                                                </Box>

                                                <Icon
                                                    as={FiTrash2}
                                                    color="danger"
                                                    onClick={(e) => { e.stopPropagation(), removeBlock(block.id, {...form}) }}
                                                    data-testid="delete_sub_nav"
                                                />
                                            </Accordion.ItemTrigger>

                                            <Accordion.ItemContent pt={4} borderRadius="none">
                                                <Accordion.ItemBody>
                                                    <SettingsNavPoint
                                                        order_number={blocks.indexOf(block)}
                                                        parent_order_number={block_num}
                                                        me_create={me_create}
                                                        me_read={me_read}
                                                        ct_read={ct_read}
                                                        categories_list={categories_list}
                                                        form={form}
                                                    />
                                                </Accordion.ItemBody>
                                            </Accordion.ItemContent>
                                        </Accordion.Item>
                                    )}
                                </SortableItem>
                            ))}
                        </Accordion.Root>
                    </SortableContext>
                </DndContext>

                <Tooltip showArrow content="Navigationspunkt hinzufügen" openDelay={500}>
                    <Box>
                        <Button
                            onClick={() => addBlock(block_num, insert, form, setOpenItems)}
                            w="100%"
                            h="fit-content"
                            py={2}
                            backgroundColor="transparent"
                            color="main"
                            data-testid="add_sub_nav"
                        >
                            <Icon as={FiPlusCircle} boxSize="25px" />
                        </Button>
                    </Box>
                </Tooltip>
            </Box>
        </SettingsNavPoint>
    )
}

export default SettingsNavPoints